import type { Components } from '@mui/material/styles'

import type { Theme } from '../types'

export const MuiButtonGroup = {
	defaultProps: { disableRipple: true },
	styleOverrides: {
		grouped: {
			'&:not(:last-child)': {
				borderColor: 'var(--Button-outlinedBorder)',
			},
			'&.Mui-disabled': {
				borderColor: 'var(--Button-outlinedBorder)',
			},
		},
	},
} satisfies Components<Theme>['MuiButtonGroup']
